<div class="container">
  <div class="row middle-row">
    <div class="txt"></div>
    <div class="legendbox legendBoxTop">
      <div style="background-color: #cecece"></div>
      <strong>Asset Idle</strong>
      <div style="background-color: #3fbddd"></div>
      <strong>Asset Running</strong>
      <div style="background-color: #999999"></div>
      <strong>Offline</strong>
      <div style="background-color: #72ff13"></div>
      <strong>Healthy</strong>
      <div style="background-color: #faa700"></div>
      <strong>Unsatisfactory</strong>
      <div style="background-color: #ff2a1b"></div>
      <strong>Unacceptable</strong>
      <div style="background-color: #fcda42"></div>
      <strong>Out for service</strong>
    </div>
  </div>
</div>